// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"89e79da3","46":"63b7ccc0","193":"c87751eb","216":"5d46bf8c","257":"0473a2f7","475":"dcf7bb1a","669":"07fcc093","773":"6a3c68c3","925":"4f2fe926","986":"1bb62644"}[chunkId] + ".chunk.js";
};